<!-- eslint-disable vue/multi-word-component-names -->
<script>
  import AppTitleHeader from '@/components/app/TitleHeader.vue';
  import AppBox from '@/components/app/box.vue';
  import AppConversation from '@/components/app/conversation.vue';
  import AppDateViewer from '@/components/app/dateViewer.vue';
  export default {
    components: { AppTitleHeader, AppBox, AppConversation, AppDateViewer },
    props: {
      patients: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        selectedPatient: {},
      };
    },
    methods: {
      selectPatient: function (patient) {
        this.selectedPatient = patient;
      },
      isSelected: function (id) {
        return this.selectedPatient?.id === id;
      },
    },
    watch: {
      patients: {
        handler: function (currentVal) {
          this.selectedPatient = currentVal[0];
        },
        immediate: true,
      },
      selectedPatient: {
        handler(currentValue) {
          if (currentValue) this.$emit('changePatient', currentValue?.id);
        },
      },
    },
  };
</script>
<template>
  <v-row no-gutters>
    <!-- <v-btn @click="selectitem('hello')" dark color="primary"> hello </v-btn> -->
    <v-col cols="12" class="pa-4">
      <app-title-header title="جزئیات 115" class="mb-4" />
      <app-box outlined max-height="55px">
        <div class="flex-gap-2 justify-between">
          <app-conversation
            :between="true"
            question="نام و نام خانوادگی"
            :answer="selectedPatient?.fullName"
            class="flex-grow"
          />
          <div class="seperator flex-shrink-0"></div>
          <app-conversation :between="true" question="حدود سن" class="flex-grow">
            <template v-slot:answer>
              <div class="flex-gap-1 font-weight-medium">
                <div>
                  {{ selectedPatient?.yearOfAge }}
                </div>
                <div>سال</div>
              </div>
            </template>
          </app-conversation>
        </div>
      </app-box>
    </v-col>
    <v-col cols="12" class="pa-4">
      <app-title-header title="مددجویان" class="mb-4" />
      <app-box outlined max-height="185px" class="">
        <div
          v-for="patient in patients"
          :key="patient?.id"
          has-bg
          @click="selectPatient(patient)"
          class="patient-box my-2 flex items-center"
          max-height="3rem"
          :class="{ 'selected-patient-box py-2': isSelected(patient?.id) }"
        >
          <div class="flex gap-2 justify-between width-full">
            <v-icon v-if="isSelected(patient?.id)" dark color="darkColor">mdi-check-circle</v-icon>
            <app-conversation question="نام و نام خانوادگی" :answer="patient?.fullName" />
            <div class="seperator"></div>
            <app-conversation question="جنسیت" answer="مرد" />
            <app-conversation question="سن" :answer="patient?.yearOfAge" />
            <app-conversation question="زمان شروع علائم">
              <template v-slot:answer>
                <app-date-viewer :date="patient?.dateOfOnset" class="font-weight-bold" />
              </template>
            </app-conversation>
          </div>
        </div>
      </app-box>
    </v-col>
  </v-row>
</template>
<style lang="scss" scoped>
  .seperator {
    height: 20px;
    width: 1px;
    background-color: #21212133;
  }

  .selected-patient-box {
    border: 2px solid var(--v-darkColor-base);
  }
  .patient-box {
    padding: 1rem;
    cursor: pointer;
    position: relative;
    transition: all 0.25s ease-in-out;
    height: 4rem;
    background-color: var(--background-color);
    border-radius: 6px;
  }
</style>
